import httpClient from "../../../client/httpClient";

export const fetchSellers = async (payload = {}, signal) => {
    const {
        filters = { status: "APPROVE" },
        pagination = { page: 1, pageSize: 5 },
        sorting = { sortBy: "id", sortOrder: "DESC" }
    } = payload;

    const searchByShopName = filters.shopName?.trim().length > 0;
    const trimmedShopName = searchByShopName ? filters.shopName.trim() : null;

    try {
        const endpoint = searchByShopName
            ? "v1/api/seller/get-seller-by-status-and-shopname"
            : "v1/api/seller/get-seller-by-status";

        // Build params helper
        const buildParams = (status, includeShopName = false) => {
            const params = {
                status: status === "ALL" ? "" : status,
                page: pagination.page,
                size: pagination.pageSize,
                sortBy: sorting.sortBy,
                sortDir: sorting.sortOrder
            };

            if (includeShopName && trimmedShopName) {
                params.shopName = trimmedShopName;
            }

            return new URLSearchParams(params);
        };

        // Fetch main data and counts in parallel
        const [mainResponse, ...countResponses] = await Promise.allSettled([
            httpClient.get(`${endpoint}?${buildParams(filters.status, searchByShopName)}`, {
                signal
            }),
            // Fetch counts from base endpoint without shopName filter
            ...["APPROVE", "PENDING", "DECLINE"]
                .filter((status) => status !== filters.status)
                .map((status) =>
                    httpClient.get(
                        `v1/api/seller/get-seller-by-status?${buildParams(status, false)}`,
                        { signal }
                    )
                )
        ]);

        if (mainResponse.status === "rejected") {
            throw mainResponse.reason;
        }

        const allStatuses = ["APPROVE", "PENDING", "DECLINE"];
        const otherStatuses = allStatuses.filter((s) => s !== filters.status);

        const counts = {
            [filters.status.toLowerCase()]: mainResponse.value.data.totalElements || 0
        };

        countResponses.forEach((response, index) => {
            const status = otherStatuses[index].toLowerCase();
            counts[status] =
                response.status === "fulfilled" ? response.value.data.totalElements || 0 : 0;
        });

        return {
            ...mainResponse.value.data,
            counts
        };
    } catch (error) {
        console.error("Error fetching sellers:", error?.response || error.message || error);
        throw error;
    }
};
